import React, { useRef } from 'react';

import styled from '@emotion/styled';

import Img from '../Img/Img';
import { ModalProvider } from '../../context/ModalContext';
import ModalTriggerContainer from '../Modals/ModalTriggerContainer';
import { Modal } from '../Modals/Modal';
import LocumProfileModal from '../Modals/ModalsActions/LocumProfileModal';
import ModalContainer from '../Modals/ModalContainer';
import InviteToApplyButton from '../../pages/Dashboard/Findlocum/InviteToApplyButtton';
import { DEFAULT_IMAGE_URL, truncateTextByCharacters } from '../../utils/utils';
import { ILocumData } from '../../models/directory/locum.model';
import GuestPromptModal from '../Modals/ModalsActions/GuestPromptModal';

interface More {
  locumId: string;
  guest?: boolean;
}

interface LocumCardProps extends ILocumData {
  isMobile: boolean;
  clickedIdAction?: () => void;
  className?: string;
  guest?: boolean;
}

const ShowModal = React.forwardRef<HTMLDivElement, More>(
  ({ locumId, guest }, ref) => {
    return (
      <ModalProvider>
        <ModalTriggerContainer ref={ref} display="none">
          <></>
        </ModalTriggerContainer>
        <Modal>
          {guest ? (
            <GuestPromptModal locum />
          ) : (
            <ModalContainer maxwidth='63rem' padding='2rem'>
              <LocumProfileModal locumId={locumId} />
            </ModalContainer>
          )}
        </Modal>
      </ModalProvider>
    );
  }
);

// export interface ILocumCard {
//   id: string;
//   firstName: string;
//   lastName: string;
//   email: string;
//   bio: string;
//   yearsOfExperience: number;
//   location: string;
//   occupation: string;
// }

const LocumCard: React.FC<LocumCardProps> = ({
  firstName,
  lastName,
  bio,
  yearsOfExperience,
  state,
  occupation,
  id,
  profileImage,
  isMobile,
  clickedIdAction,
  className,
  guest,
}) => {
  const triggerRef = useRef<HTMLDivElement>(null);

  const handleClick = () => {
    triggerRef.current?.click();
  };

  const handleClick2 = () => {
    !guest && clickedIdAction && clickedIdAction();
  };

  if (!isMobile) {
    // on PC (wider than 480px) render nothing
    return (
      <Container2 onClick={handleClick2} className={className}>
        {' '}
        <UpperSection>
          <ImageContainer>
            <Img src={profileImage ?? DEFAULT_IMAGE_URL} alt="locum" />
          </ImageContainer>
          <div>
            <UpperSectionTitle>
              {lastName} {truncateTextByCharacters(firstName, 6)}
              <div
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                {/* <InviteToApplyButton
                  name={`${firstName} ${lastName}`}
                  invitedUserId={id}
                /> */}
              </div>
            </UpperSectionTitle>
            <UpperSectionDescription>
              <span>{truncateTextByCharacters(bio ?? 'N/A', 65)}</span>
            </UpperSectionDescription>
            <Xp>Exp {yearsOfExperience} yrs</Xp>
          </div>
        </UpperSection>
        <BottomSection>
          <FlexContainer>
            <BottomSectionLabel>Location</BottomSectionLabel>
            <BottomSectionLabel>Job Title</BottomSectionLabel>
          </FlexContainer>
          <FlexContainer>
            <BottomSectionData>{state ?? 'N/A'}</BottomSectionData>
            <BottomSectionData>
              {truncateTextByCharacters(occupation ?? 'N/A', 15)}
            </BottomSectionData>
          </FlexContainer>
        </BottomSection>
      </Container2>
    );
  }

  return (
    <>
      <Container onClick={handleClick}>
        <UpperSection>
          <ImageContainer>
            <Img src={profileImage ?? DEFAULT_IMAGE_URL} alt="locum" />
          </ImageContainer>
          <div>
            <UpperSectionTitle>
              {lastName} {truncateTextByCharacters(firstName, 6)}
              <div
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                {guest ? (
                  <ModalProvider>
                    <ModalTriggerContainer>
                      <GuestInvite>Invite to apply</GuestInvite>
                    </ModalTriggerContainer>

                    <Modal>
                      <GuestPromptModal locum />
                    </Modal>
                  </ModalProvider>
                ) : (
                  <InviteToApplyButton
                    name={`${firstName} ${lastName}`}
                    invitedUserId={id}
                  />
                )}
              </div>
            </UpperSectionTitle>
            <UpperSectionDescription>
              <span>{truncateTextByCharacters(bio ?? 'N/A', 65)}</span>
            </UpperSectionDescription>
            <Xp>Exp {yearsOfExperience} yrs</Xp>
          </div>
        </UpperSection>
        <BottomSection>
          <FlexContainer>
            <BottomSectionLabel>Location</BottomSectionLabel>
            <BottomSectionLabel>Job Title</BottomSectionLabel>
          </FlexContainer>
          <FlexContainer>
            <BottomSectionData>{state ?? 'N/A'}</BottomSectionData>
            <BottomSectionData>
              {truncateTextByCharacters(occupation ?? 'N/A', 15)}
            </BottomSectionData>
          </FlexContainer>
        </BottomSection>
      </Container>
      <ShowModal ref={triggerRef} locumId={id} guest={guest} />
    </>
  );
};

export default LocumCard;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  color: black;
  border-radius: 0.25rem;
  border: 1.4px solid ${({ theme }) => theme.palette.greyGrey3};
  background-color: ${({ theme }) => theme.palette.white};
  min-height: 12rem;
  max-height: 12rem;
  overflow: hidden;
  width: 100%;
  min-width: 390px;
  max-width: 390px;

  //mobile-specific styles
  @media (max-width: 860px) {
    border: none;
    box-shadow: -1px 5px 5px 0px rgba(0, 0, 0, 0.03);
    width: 100%;
    min-width: 0;
    max-width: 600px;
  }
`;

const Container2 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  color: black;
  border-radius: 0.25rem;
  border: 1.4px solid ${({ theme }) => theme.palette.greyGrey3};
  background-color: ${({ theme }) => theme.palette.white};
  min-height: 10rem;
  max-height: 12rem;
  overflow: hidden;
  width: 100%;
  min-width: 300px;
  max-width: 300px;
  cursor: pointer;

  &.active {
    border: 1px solid ${({ theme }) => theme.palette.mainBlue};
    background-color: ${({ theme }) => theme.palette.blueLight};
  }

  //mobile-specific styles
  @media (max-width: 860px) {
    background-color: ${({ theme }) => theme.palette.white};
    box-shadow: -1px 5px 5px 0px rgba(0, 0, 0, 0.03);
    width: 100%;
    min-width: 0;
    max-width: 600px;
  }
`;

const UpperSection = styled.div`
  display: grid;
  grid-template-columns: 50px auto;
  gap: 0.5rem;
  padding: 0.5rem;

  @media (max-width: 480px) {
    grid-template-columns: 30px auto;

    & > div {
    }
  }
`;

const UpperSectionTitle = styled.div`
  font-weight: 400;
  line-height: normal;
  display: flex;
  justify-content: space-between;

  //mobile-specific styles
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const UpperSectionDescription = styled.div`
  font-size: 0.872rem;
  font-weight: 300;
  color: ${({ theme }) => theme.palette.greyGrey1};

  //mobile-specific styles
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const ImageContainer = styled.div`
  height: fit-content;
  border-radius: 50%;
  overflow: hidden;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 480px) {
    height: 30px;
  }
`;

const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0.875rem;
  border-top: 1px solid ${({ theme }) => theme.palette.borderColor};
`;

const BottomSectionLabel = styled.div`
  font-weight: 400;
  line-height: normal;
  color: ${({ theme }) => theme.palette.greyGrey2};

  //mobile-specific styles
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const BottomSectionData = styled.div`
  font-weight: 400;
  line-height: normal;
  color: ${({ theme }) => theme.palette.blackBlackMain};

  //mobile-specific styles
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Xp = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  font-size: 12px;
  font-weight: 400;
  line-height: 100%;
  letter-spacing: -2%;
  color: ${({ theme }) => theme.palette.greyGrey2};
`;

const GuestInvite = styled.p`
  color: ${({ theme }) => theme.palette.mainBlue};
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: -2%;
  text-wrap: nowrap;
  cursor: pointer;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
